export const SAME_AS_BILLING_ADDRESS = 'same as billing address'

export function individualMatches (term, values, skipExact = []) {
  const needle = term.trim().toLowerCase()
  const skipped = new Set(skipExact.map((value) => String(value).toLowerCase()))
  const seen = new Set()

  return values.reduce((matches, value) => {
    const text = String(value ?? '').trim()
    const key = text.toLowerCase()
    if (!text || skipped.has(key) || !key.includes(needle) || seen.has(key)) return matches
    seen.add(key)
    matches.push(text)
    return matches
  }, [])
}
